export type FeeProductType = 'LOAN' | 'SAVINGS' | 'CURRENT';

export type FeeScheduleType =
  | 'TIME'
  | 'DAY_OF_WEEK'
  | 'DAY_OF_MONTH'
  | 'QUARTER_MONTHS'
  | 'HALF_MONTHS'
  | 'MONTH'
  | 'NONE';

export interface FeeEventType {
  event: string;
  scheduleType: FeeScheduleType;
  label: string;
  hint?: string;
  appliesTo: FeeProductType[];
}

/** Mapped/transformed version of FeeEventType used in dropdowns (event → value) */
export interface FeeEventOption {
  label: string;
  value: string;
  scheduleType: FeeScheduleType;
}

export interface SubValueOption {
  label: string;
  value: string;
}

export interface FeeChargeRow {
  _uid?: number;   // internal drag-drop tracking key — never sent to API
  id?: number;
  chargeId: number | null;
  chargeType: string;
  value: string;
  minimumValue: string;
  maximumValue: string;
  eventType: string;
  eventSubValue: string;
  monthlyCustomDay: string;
  q1Month: string; q2Month: string; q3Month: string; q4Month: string;
  h1Month: string; h2Month: string;
}

export interface FeeChargeConfig {
  id?: number;
  chargeId: number;
  chargeType: string;
  chargeAmount: number;
  minValue: number;
  maxValue: number;
  feeEvent: string;
  scheduleDetail?: string;
  quarterOneMonth?: string;
  quarterTwoMonth?: string;
  quarterThreeMonth?: string;
  quarterFourMonth?: string;
  firstHalfMonth?: string;
  secondHalfMonth?: string;
  sortOrder?: number;
}
